import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "w-fit h-fit" };
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import { computed } from 'vue';
import { EmployeeCardStore } from "@common/stores";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CEmployeeAvatar',
    props: {
        colorId: {},
        icon: {},
        primary: { type: Boolean },
        src: {},
        name: {},
        employee: {},
        uuid: {}
    },
    emits: ["close", "click"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var emits = __emit;
        var props = __props;
        var employeeCardStore = EmployeeCardStore;
        var employeeSrc = computed(function () {
            var _a;
            return props.src || ((_a = props.employee) === null || _a === void 0 ? void 0 : _a.user.avatar);
        });
        var employeeName = computed(function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = props.employee) === null || _a === void 0 ? void 0 : _a.user.name[0]) !== null && _b !== void 0 ? _b : props.name) !== null && _c !== void 0 ? _c : '';
        });
        var handleShow = function () {
            if (props.employee) {
                employeeCardStore.employee = props.employee;
                employeeCardStore.show();
            }
            else if (props.uuid) {
                employeeCardStore.getEmployee(props.uuid);
                employeeCardStore.show();
            }
        };
        return function (_ctx, _cache) {
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_e_button, {
                    class: "w-[inherit] h-[inherit]",
                    size: "nosize",
                    type: "text",
                    onClick: handleShow
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EAvatar, {
                            "color-id": _ctx.colorId,
                            icon: _ctx.icon,
                            name: employeeName.value,
                            primary: _ctx.primary,
                            src: employeeSrc.value,
                            class: "!w-[inherit] !h-[inherit] cursor-pointer"
                        }, null, 8, ["color-id", "icon", "name", "primary", "src"])
                    ]; }),
                    _: 1
                })
            ]));
        };
    }
});
